import { postAsync, getAsync } from './_base';

const postUpdateMiniCart = (lineItemId?: string, quantity?: number, updateApiUrl?: string) => {
  return postAsync(updateApiUrl ?? '', undefined, {
    lineItemId: lineItemId,
    quantity: quantity,
  });
};

const postDeleteMiniCartItem = (lineItemId?: string, deleteApiUrl?: string) => {
  return postAsync(deleteApiUrl ?? '', undefined, {
    lineItemId: lineItemId,
  });
};
const postDeleteAllMiniCartItem = (deleteApiUrl?: string) => {
  return postAsync(deleteApiUrl ?? '', undefined, {});
};

const postSaveQuote = (saveQuotesURL?: string) => {
  return postAsync(saveQuotesURL ?? '');
};

const getQuotesCount = (userName?: string, getQuotesCountApiUrl?: string) => {
  return getAsync(getQuotesCountApiUrl ?? '', {
    userName: userName,
  });
};

const getGetCartInfo = (getCartInfoURL?: string) => {
  return getAsync(getCartInfoURL ?? '');
};

export { postUpdateMiniCart, postDeleteMiniCartItem, postDeleteAllMiniCartItem, getQuotesCount, postSaveQuote, getGetCartInfo };
